import { useMemo } from "react";
import { useAppSelector, selectors } from "store";
import { useChartTimeline, percentToDisplayTime, } from "ui/components/elements/chart/chart-timeline";
import { xAxisKey, airConsumptionYAxisKey, } from "ui/components/panels/graphs/constants";
var stepAfterLookup = function (data, apiTime) {
    var _a, _b;
    if (!data.length)
        return 0;
    var idx = -1;
    for (var i = 0; i < data.length; i++) {
        if (data[i][xAxisKey] <= apiTime)
            idx = i;
        else
            break;
    }
    if (idx === -1)
        return (_a = data[0][airConsumptionYAxisKey]) !== null && _a !== void 0 ? _a : 0;
    return (_b = data[idx][airConsumptionYAxisKey]) !== null && _b !== void 0 ? _b : 0;
};
/**
 * Returns the air consumption value at the current play position,
 * or undefined when graph data is not yet available.
 */
export var useCurrentAirConsumption = function () {
    var playLocationPercent = useAppSelector(selectors.selectPlayLocationPercent);
    var parsedGraphData = useAppSelector(selectors.selectParsedGraphData);
    var timeline = useChartTimeline();
    return useMemo(function () {
        if (!parsedGraphData || !timeline)
            return undefined;
        var airConsumptionData = parsedGraphData.airConsumptionData;
        if (!airConsumptionData.length)
            return undefined;
        // Same percent→display-time mapping as the graph PlayLine (see
        // use-current-vacuum-level) so the value tracks the rendered play head.
        var apiTime = percentToDisplayTime(playLocationPercent, timeline);
        return stepAfterLookup(airConsumptionData, apiTime);
    }, [parsedGraphData, timeline, playLocationPercent]);
};
